// extracted by mini-css-extract-plugin
export default {"metadataContainer":"MetadataContainer-module__metadataContainer--OVo0K"};